import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { amountFormatUse, convertDecimalToTime, utc_local } from '../helpers/Helper';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { post } from '../helpers/api_helper';
import { POST_EMPLOYEE_ATTENDANCE} from '../helpers/url_helper';


function EditAttendance(props) {
    const { t } = useTranslation();

    const [employeeOverTimeHours, SetEmployeeOverTimeHours] = useState(0);
    const [employeeOverTimeMinutes, SetEmployeeOverTimeMinutes] = useState(0);
    const [employee, setEmployee] = useState({ 
        atId: 0, 
        employeeId: '', 
        date : '', 
        attendanceType: '', 
        workingHours: 0, 
        overTime: 0, 
        overTimeHours: '', 
        overTimeMinutes: '', 
        name: '',
        totalAmount: 0, 
        salaryType : '',
        salary: 0, 
    })
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [Overtime, SetOvertime] = useState(false);

    useEffect(() => {
        if(props.attendanceInfo){
            const [overTimeHours,overTimeMinutes] = convertDecimalToTime(props.attendanceInfo.overTimeHours).split(':');
            setEmployee({
                atId: props.attendanceInfo.id, 
                employeeId: props.attendanceInfo.employeeId, 
                date : props.attendanceInfo.date, 
                attendanceType: (props.attendanceInfo.attendanceType !== 'Over Time')? props.attendanceInfo.attendanceType : 'Full Day', 

                overTime: props.attendanceInfo.overTimeHours, 
                workingHours: props.attendanceInfo.workingHours, 
                overTimeHours: overTimeHours, 
                overTimeMinutes: overTimeMinutes, 
                name: props.attendanceInfo.name,
                totalAmount: props.attendanceInfo.totalAmount,
                salaryType: props.attendanceInfo.salaryType,
                salary: props.attendanceInfo.salary,
            })

        }
        console.log(props.attendanceInfo);
    },[props])

    const attendance = async (type, employee, overTimeHours = 0, overTimeMinutes = 0) => {
        if (overTimeHours === '') {
            toast.error('Please Enter You Hours');
            return;
        }
        if (overTimeMinutes === '') {
            toast.error('Please Enter You Minutes');
            return;
        }
        type = ((overTimeHours > 0 || overTimeMinutes > 0) && employee.attendanceType === 'Absent') ? 'Absent' : type;

        SetButtonDisabled(true);
        const api_post_data = {
            employeeId: employee.employeeId,
            date: employee.date,
            workingHours: employee.workingHours,
            salaryType: employee.salaryType,
            salary: employee.salary,
            attendanceType: type,
            overTimeHours: overTimeHours,
            overTimeMinutes: overTimeMinutes,
            offset: -new Date().getTimezoneOffset()
        }
        console.log(api_post_data);
        var api_res = await post(POST_EMPLOYEE_ATTENDANCE, api_post_data);
        if (api_res.status) {
            $('.modal-close').click();
            props.call_back()
        } else {
            toast.error(api_res.message);
        }
        SetButtonDisabled(false);
    }

    const overTimeModal = async () => {
        SetOvertime(employee.salaryType !== 'Per Hour');
    }

    const allowOnlyNumbers = (e) => {
        const value = e.target.value;
        const regex = /^\d*$/; // Only digits (no dot allowed)

        if (!regex.test(value)) {
            e.target.value = value.replace(/\D/g, ''); // Remove all non-digits
        }
        if (e.target.name === 'employeeOverTimeMinutes') {
            if (value > 59) {
                e.target.value = 59
            } else if (value && value <= 0) {
                e.target.value = ''
            }
        }
    }

    return (
        <>
            <div className="modal fade" id="editModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Edit Attendance</h5>
                            <button type="button" className="btn btn-sm modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='mb-3'>
                                <p className='mb-0'>Name : {employee.name}</p>
                                <small className='mb-0'>Date : {utc_local(employee.date,'ddd, DD/MM/YYYY')}</small>
                            </div>
                            <div class="d-flex gap-2 mb-2 attendance-btn">
                                {employee.salaryType !== 'Per Hour' && <>
                                    <button disabled={ButtonDisabled} onClick={() => { attendance('Full Day', employee) }} class={`btn btn-sm btn-outline-success ${((employee.attendanceType === 'Full Day')) ? 'active' : ''}`}>PRESENT</button>
                                    <button disabled={ButtonDisabled} onClick={() => { attendance('Half Day', employee) }} class={`btn btn-sm btn-outline-info ${((employee.attendanceType === 'Half Day')) ? 'active' : ''}`}>HALF DAY</button>
                                </>}
                                <button disabled={ButtonDisabled} onClick={() => { attendance('Absent', employee) }} class={`btn btn-sm btn-outline-danger ${((employee.attendanceType === 'Absent')) ? 'active' : ''}`}>ABSENT</button>
                                <button disabled={ButtonDisabled} class={`btn btn-sm btn-outline-warning ${((employee.overTimeHours > 0)) ? 'active' : ''}`} onClick={overTimeModal} data-bs-toggle="modal" data-bs-target="#OvertimeModal">{(employee.salaryType !== 'Per Hour') ? 'OVER TIME' : 'WORKING HOURS'}</button>
                            </div>
                            <div>
                                {employee.atId > 0 && <>
                                    {employee.attendanceType === 'Half Day' && <small class="text-info"> ✓ Marked as Half Day <span className='text-danger'> {amountFormatUse(employee.totalAmount)}</span></small>}
                                    {(employee.attendanceType === 'Full Day' && employee.overTime <= 0) && <small class="text-success">✓ Marked as Present <span className='text-danger'> {amountFormatUse(employee.totalAmount)}</span></small>}
                                    {(employee.overTime > 0) && <small class="text-warning">✓ Marked as {(employee.salaryType !== 'Per Hour') ? 'Over Time' : 'Working'} (+{convertDecimalToTime(employee.overTime)}h)  <span className='text-danger'>{amountFormatUse(employee.totalAmount)}</span></small>}

                                </>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="OvertimeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{(Overtime) ? 'Enter Overtime Hours' : 'Enter Working Hours'}</h5>
                            <button type="button" className="btn btn-sm modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-6 pe-0'>
                                    <label className='form-label text-capitalize'>Enter Hours *</label>
                                    <input type='text' className='form-control' name='employeeOverTimeHours' placeholder='Hours' value={employeeOverTimeHours} onKeyUp={allowOnlyNumbers} maxLength={2} onChange={(e) => { SetEmployeeOverTimeHours(e.target.value); }} />
                                </div>
                                <div className='col-6 ps-0'>
                                    <label className='form-label text-capitalize'>Enter Minutes *</label>
                                    <input type='text' className='form-control' name='employeeOverTimeMinutes' placeholder='Minutes' value={employeeOverTimeMinutes} onKeyUp={allowOnlyNumbers} maxLength={2} onChange={(e) => { SetEmployeeOverTimeMinutes(e.target.value); }} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={ButtonDisabled} className="btn btn-secondary" data-bs-dismiss="modal">{t('cancel')}</button>
                            <button onClick={() => { attendance('Full Day', employee, employeeOverTimeHours, employeeOverTimeMinutes); }} disabled={ButtonDisabled} className="btn btn-primary">{t('save')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditAttendance;